import Listener from '../watcher/Listener'

/**
 * Abstract class - вешает на элемент обработчик клика
 *
 */
export default class Share {
   constructor(element) {
      if (this.constructor === Share) {
         throw new Error('Can\'t instantiate abstract class!')
      }
      this.element = element
      Listener.onClick(this.element, this.onShare.bind(this, this.getParamsToShare.bind(this)()))
   }

   /**
    * Abstract method - который вызовется при клике на элемент
    *
    * @param params параметры используемые для шаринга
    */
   onShare(params) {
      throw new Error('Abstract method! onShare')
   }

   /**
    * Abstract method - должен вернтуть параметры исрользуемые при шаринге
    */
   getParamsToShare() {
      throw new Error('Abstract method! getParamsToShare')
   }
}